import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

const cookieSections = [
  ["Essential storage", "The cart uses browser storage so selected products remain available as you move between pages. This storage is necessary for the shopping experience and is not used for advertising."],
  ["Payment and security", "When you choose Pay now, you leave this site for the payment service. That provider may set essential security, fraud-prevention, and transaction cookies under its own policy."],
  ["Preferences", "The site may remember limited interface choices required to provide the feature you requested. We do not use preference data to build advertising profiles."],
  ["Analytics", "ioomparade does not currently place non-essential advertising cookies. If optional analytics are introduced, this policy and any consent controls will be updated before they are enabled where consent is required."],
  ["Managing browser storage", "You can remove cookies and site data through your browser settings. Blocking essential storage may prevent the cart or checkout from working correctly."],
  ["Policy updates", "We may update this notice when technology, providers, or legal requirements change. The latest version will always be available on this page."],
];

function Cookies() {
  return (
    <main className="ink-info-page ink-info-page--privacy">
      <div className="ink-info-page__inner">
        <header className="ink-info-page__header">
          <p className="ink-info-page__eyebrow">Your choices</p>
          <h1>Cookie Policy</h1>
          <p className="ink-info-page__lead">
            This notice explains the limited browser storage used by ioomparade and how you can manage it.
          </p>
        </header>
        <div className="privacy-sections">
          {cookieSections.map(([title, text], index) => (
            <section className="privacy-section" key={title}>
              <span className="privacy-section__number" aria-hidden="true">
                {String(index + 1).padStart(2, "0")}
              </span>
              <div><h2>{title}</h2><p>{text}</p></div>
            </section>
          ))}
        </div>
        <section className="privacy-contact">
          <div>
            <p className="ink-info-page__kicker">Related information</p>
            <h2>How we handle personal information</h2>
          </div>
          <Link className="ink-info-page__button" to="/privacy">Read the Privacy Policy</Link>
        </section>
      </div>
    </main>
  );
}

export default Cookies;
